"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PromoSlot = void 0;
var _react = _interopRequireDefault(require("react"));
var _coreThemes = require("@vfuk/core-themes");
var _coreBaseProps = require("@vfuk/core-base-props");
var _coreHeading = _interopRequireDefault(require("@vfuk/core-heading"));
var _coreImage = _interopRequireDefault(require("@vfuk/core-image"));
var _coreSpan = _interopRequireDefault(require("@vfuk/core-span"));
var _coreLinkWithIcon = _interopRequireDefault(require("@vfuk/core-link-with-icon"));
var _corePill = _interopRequireDefault(require("@vfuk/core-pill"));
var _coreIcon = _interopRequireDefault(require("@vfuk/core-icon"));
var _PromoSlot = _interopRequireDefault(require("./themes/PromoSlot.theme"));
var Styled = _interopRequireWildcard(require("./styles/PromoSlot.style"));
var _SlotWrapper = _interopRequireDefault(require("../../SlotWrapper"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var PromoSlot = function PromoSlot(_ref) {
  var promotion = _ref.promotion,
    pill = _ref.pill,
    heading = _ref.heading,
    slotWrapper = _ref.slotWrapper,
    inverse = _ref.inverse,
    linkWithIcon = _ref.linkWithIcon,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
    localTheme = _ref.localTheme,
    dataSelectorPrefix = _ref.dataSelectorPrefix;
  var componentName = 'PromoSlot';
  var promoSlotTheme = (0, _coreThemes.useLocalTheme)(componentName, _PromoSlot["default"], localTheme);
  var _ref2 = inverse ? promoSlotTheme.appearance[appearance].inverse : promoSlotTheme.appearance[appearance],
    inverseText = _ref2.inverseText,
    inverseIcon = _ref2.inverseIcon,
    inverseLink = _ref2.inverseLink,
    prefixAppearance = _ref2.prefixAppearance,
    linkAppearance = _ref2.linkAppearance,
    iconAppearance = _ref2.iconAppearance;
  return /*#__PURE__*/_react["default"].createElement(_SlotWrapper["default"], _extends({
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)
  }, slotWrapper), /*#__PURE__*/_react["default"].createElement(_coreHeading["default"], _extends({}, heading, {
    inverse: inverseText,
    size: 1,
    weight: 3,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'heading')
  })), /*#__PURE__*/_react["default"].createElement(Styled.Container, {
    hasPill: Boolean(pill)
  }, /*#__PURE__*/_react["default"].createElement(Styled.ContentWrapper, null, /*#__PURE__*/_react["default"].createElement(Styled.PromotionWrapper, null, promotion.image && /*#__PURE__*/_react["default"].createElement(Styled.ImageWrapper, null, /*#__PURE__*/_react["default"].createElement(_coreImage["default"], _extends({}, promotion.image, {
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'image')
  }))) || promotion.icon && /*#__PURE__*/_react["default"].createElement(_coreIcon["default"], _extends({}, promotion.icon, {
    size: 5,
    appearance: iconAppearance,
    inverse: inverseIcon,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'icon')
  })), /*#__PURE__*/_react["default"].createElement(Styled.TextWrapper, null, promotion.prefix && /*#__PURE__*/_react["default"].createElement(_coreSpan["default"], {
    appearance: prefixAppearance,
    weight: 1,
    inverse: inverseText,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'promotion-prefix')
  }, promotion.prefix), /*#__PURE__*/_react["default"].createElement(_coreHeading["default"], _extends({}, promotion.title, {
    inverse: inverseText,
    size: 1,
    weight: 3,
    noMargin: true,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'promotion-title')
  })), promotion.description && /*#__PURE__*/_react["default"].createElement(_coreSpan["default"], {
    inverse: inverseText,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'promotion-description')
  }, promotion.description))), linkWithIcon && /*#__PURE__*/_react["default"].createElement(_coreLinkWithIcon["default"], _extends({}, linkWithIcon, {
    icon: {
      name: linkWithIcon.icon.name,
      justify: 'left'
    },
    appearance: linkAppearance,
    inverse: inverseLink,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'link')
  }))), pill && /*#__PURE__*/_react["default"].createElement(_corePill["default"], _extends({}, pill, {
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'pill')
  }))));
};
exports.PromoSlot = PromoSlot;
PromoSlot.displayName = "PromoSlot";
var _default = PromoSlot;
exports["default"] = _default;
//# sourceMappingURL=PromoSlot.js.map